import React, {Component, Fragment, useContext} from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import * as cookie from "react-cookies";

import {AppearTransition} from "../animations";
import {Button} from "./common";
import {extractCartData, formatPrice, toggleState} from "../../lib/tools";
import {Checkbox, FormInput, ValidateForm, DatetimeInput} from "../common/formValidation";
import {reduxWrapper} from "../../globalState";
import {ModalContext} from './../../contexts';
import {getImage} from "../../lib/api";
// Icons
import checkIcon from "../../resources/icons/checkmark-limeGreen.svg";
import arrowIcon from "../../resources/icons/ic-arrow-back.svg";
import FacebookIcon from "../../resources/icons/facebook-white.svg";
import closeIcon from "../../resources/icons/x-black.svg";
import CartIcon from "../../resources/icons/cart-black.svg";

// Parent module fror all Modals, provides joined functionality and markup
export class Modal extends Component {
	static propTypes = {
		children: PropTypes.node,
		className: PropTypes.string,
		onHide: PropTypes.func
	} 

	render() {
		let {children, className, onHide, bg = false, skip = false} = this.props;

		return (
			<div className={["modalBackground", className].join(" ")} onClick={onHide}>
				{ bg &&
					<img src={closeIcon} onClick={onHide} alt="Luk"/>
				}
				<div className="modal"
					onClick={e => e.stopPropagation()}
				>
					<div className="modalContent">
						{children}
					</div>
					{ skip && 
						<span className="skipBtn" onClick={onHide}>Spring over</span>
					}
				</div>
			</div>
		);
	}
}

// Shows an e-mail registration form
class OnBoardingModalRender extends Component {
	static contextType = ModalContext;

	static propTypes = {
		children: PropTypes.node,
		className: PropTypes.string,
		onHide: PropTypes.func
	};

	state = {
		finished: false,
		invalidMail: false
	};
	
	submit = ({newsletter, email}) => {
		this.props.apiCall("POST", "/login/email", () => {
			this.setState({finished: true});
			setTimeout(() => {
				this.context.toggleModal(false);
			}, 2000);

			// Pushing event data to GTM datalayer
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'GemFest',
			})

		}, {email}, () => this.setState(toggleState('invalidMail')));
	};
	
	onHide = () => {
		this.context.toggleModal(false);
	};
	
	componentDidMount(){
		cookie.save('SaveParty', 'Shown');
	}

	render() {
		return (
			<Modal className="onBoardingModal" onHide={this.onHide} skip>
			{
				this.state.finished ?
					<Fragment>
						<h1>Gemt</h1>
						<span>Du modtager en mail til at oprette en profil</span>
						<img src={checkIcon} alt="Gemt"/>
					</Fragment> :
					this.state.invalidMail ? 
						<Fragment>
							<h1>Denne email er allerede tilknyttet en bruger</h1>
							<Button onClick={() => this.context.toggleModal(true, <LoginModal/>)}>Log ind istedet</Button>
							<Button className="light" onClick={() => this.setState(toggleState('invalidMail'))}>Prøv igen</Button>
						</Fragment>:					
						<Fragment>
							<h1 className="title-m">Skal vi gemme din fest?</h1>
							<p>Du har mulighed for at arbejde videre på din fest, helt op til 8 dage før festen skal afholdes.</p>
							<ValidateForm onSubmit={this.submit} className="ga-gemFest">
								<FormInput name="email" rules="email" type="email" req/>
								<Checkbox name="newsletter" title="Tilmeld nyhedsbrev"/>
								<Link to="/brugsbetingelser-datapolitik">Læs vilkår og betingelser</Link>
								<Button submit>Ja</Button>
							</ValidateForm>
						</Fragment>
			}
			</Modal>
		);
	}
}
export const OnBoardingModal = reduxWrapper("getApiCall")(OnBoardingModalRender);

export const ProductModal = ({children, onHide, section}) => (
	<div className="productModalBackground">
		<div className="productModal maxWidth"
		     onClick={e => e.stopPropagation()}
		>
			<div className="productModalTop">
				<img className="closeModal" src={arrowIcon} onClick={onHide}/>
				<span>{section}</span>
			</div>
			<div className="productModalContent">
				{children}
			</div>
		</div>
	</div>
);

class LoginModalRender extends Component {
	static contextType = ModalContext;
	state = {
		error: null
	};

	prompt = {
		text: "Du er nu logget ind",
		confirm: () => {
			this.props.transferParties({
				success: () => {
					this.props.invalidateUserToken({ignoreGroup: true}); 
					this.onHide();
				}
			});
		},
		decline: () => {
			this.props.invalidateUserToken({ignoreGroup: true});
			this.onHide();
		}
	};

	runPrompt = (data = null) => {
		// if (this.props.onHide) return;
		// else if (data && data.oldParties) {
		// 	this.context.toggleModal(true, 
		// 		<PromptModal {...this.prompt}>
		// 			<span>
		// 				Du var igang med en fest på din gæstekonto.<br/>
		// 				Vil du tilføje den til din bruger?
		// 			</span>
		// 		</PromptModal>)
		// }
		// else{
		// 	this.context.toggleModal(true, <SuccessModal text="Du er nu logget ind" />);
		// }
		this.props.invalidateUserInfo();
		this.context.toggleModal(true, <SuccessModal text="Du er nu logget ind" />);
	};

	onHide = () => {
		if (this.props.onHide) this.props.onHide();
		else this.context.toggleModal(false);
	};

	render() {
		const {facebookLogin, login} = this.props;
		const {toggleModal} = this.context;

		return (
			<Modal onHide={this.onHide} className="loginModals loginModal" bg>
				<div className="loginMainWrapper">
					<div className="loginMain">
						<h1>Log ind på Festen.dk</h1>
						<div
							className="facebookLogin"
							onClick={() => facebookLogin({
								success: data => this.runPrompt(data), 
								error: error => this.setState({error})
							})}
						>
							<img src={FacebookIcon} alt="Log ind med Facebook"/>
							Log ind med Facebook
						</div>
						<span>ELLER</span>
						<ValidateForm 
							onSubmit={data => login({data, success: (data) => this.runPrompt(data), error: (error) => this.setState({error})})} 
							className="login"
						>
							<AppearTransition animation="growCenter" show={this.state.error != null}>
								<p className="error">{this.state.error}</p>
							</AppearTransition>
							<FormInput name="email" rules="email" type="email" req/>
							<div className="loginPassWrapper">
								<FormInput name="password" title="Kodeord" type="password" placeholder="Password" req/>
								<span 
									className="forgotPassBtn" 
									onClick={() => toggleModal(true, <ForgotPassModal onHide={this.onHide} goBack={toggleModal}/>)}
								>
									Glemt?
								</span>
							</div>
							<Button className="ga-logIn" submit>Log ind</Button>
						</ValidateForm>
					</div>
				</div>
				<div className="loginBotWrapper">
					<div className="loginBot">
						<span>Har du ikke en profil endnu?</span>
						<Button className="reverse" onClick={() => toggleModal(true, 
							<RegisterModal 
								onHide={this.onHide}
								onFBLogin={() => facebookLogin({success: toggleModal(true, <SuccessModal text="Du er nu logget ind" />), showError: true})}
								goBack={toggleModal}
							/>)}
						>
							Opret ny bruger
						</Button>
					</div>
				</div>
			</Modal>
		)
	}
}
export const LoginModal = reduxWrapper(
	"getLogin", 
	"getFacebookLogin", 
	"getUserId", 
	"getTransferParties", 
	"invalidateUserToken",
	"invalidateUserInfo"
)(LoginModalRender);

// Sign up as new user
class RegisterModalRender extends Component {
	static contextType = ModalContext;

	state = {
		mailExists: false
	}
	render() {
		const {register, onFBLogin, onHide, goBack} = this.props;
		const {toggleModal} = this.context;
		return (
			<Modal onHide={onHide} className="loginModals registerModal" bg>
				<div className="loginMainWrapper">
					<div className="loginMain">
						<h1>Opret profil</h1>
						{/* TODO: Check if Facebook login works on live */}
						<div className="facebookLogin" onClick={() => onFBLogin({showError: true})}>
							<img src={FacebookIcon} alt="Log ind med Facebook"/>
							Log ind med Facebook
						</div>
						<span>ELLER</span>
						<ValidateForm 
							className="register" 
							onSubmit={data => register({
								data, 
								success: () => toggleModal(true, <SuccessModal text="Du har nu oprettet en bruger"/>), 
								error: () => this.setState(toggleState("mailExists")),
								showError: true
							})} 
						>
							{	this.state.mailExists && 
								<span className="error">Denne email er allerede tilknyttet en bruger</span>
							}
							<FormInput name="email" type="email" rules="email" req/>
							<FormInput name="name" title="Navn" req/>
							<FormInput password={true} name="password"/>
							<Button submit>Opret</Button>
						</ValidateForm>
					</div>
				</div>
				<div className="loginBotWrapper">
					<div className="loginBot">
						<span>Har du allerede en profil?</span>
						<Button className="reverse" onClick={() => goBack(true, <LoginModal/>)}>
							Log ind
						</Button>
					</div>
				</div>
			</Modal>
		)
	}
}
const RegisterModal = reduxWrapper("getRegister")(RegisterModalRender);

// To reset user password
class ForgotPassModalRender extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			email: "",
			sent: false
		};
		
		this.onSubmit = ({email}) => {
			this.props.apiCall("POST", "/login/forgot", data => {
				this.setState({email: email, sent: true});
			}, {email});
		}
	}
	
	render() {
		const {goBack, onHide} = this.props;
		return (
			<Modal onHide={onHide} className="loginModals forgotModal" bg>
				<div className="loginMainWrapper">
					<div className="loginMain">
						<h1>Glemt adgangskode</h1>
						<span>
							Indtast din email, og få tilsendt
							et link til at nulstille din kode
						</span>
						{this.state.sent ?
							<div className="confirmation">
								Email sent to <span>{this.state.email}</span>
							</div> :
							<ValidateForm className="forgot" onSubmit={this.onSubmit}>
								<FormInput name="email" type="email" rules="email" req/>
								<Button submit>Nulstil</Button>
							</ValidateForm>
						}
					</div>
				</div>
				<div className="loginBotWrapper">
					<div className="loginBot">
						<span>Kan du huske din kode?</span>
						<Button className="reverse" onClick={() => goBack(true, <LoginModal/>)}>Log ind</Button>
					</div>
				</div>
			</Modal>
		);
	}
}
const ForgotPassModal = reduxWrapper("getApiCall")(ForgotPassModalRender);

// Yes/No propmt modal
export class PromptModal extends Component {
	static contextType = ModalContext;
	static propTypes = {
		text: PropTypes.string,
		confirm: PropTypes.func,
		decline: PropTypes.func,
		confirmText: PropTypes.string,
		declineText: PropTypes.string,
	};

	render(){
		const {text, confirm, decline = null, confirmText = "Ja", declineText = "Nej", children} = this.props;
		return(
			<Modal className="promptModal" skip>
				<h1>{text}</h1>
				{children}
				<Button className="light" onClick={() => confirm()}>{confirmText}</Button>
				<Button onClick={() => decline && decline()}>{declineText}</Button>
			</Modal>
		)
	}
}

export class SuccessModal extends Component {
	static contextType = ModalContext;

	static propTypes = {
		text: PropTypes.string
	};

	componentDidMount(){
		setTimeout(() => {
			this.context.toggleModal(false);
		}, 2000);
	}
	
	render(){
		const {text} = this.props;
		return(
			<Modal className="successModal">
				<h1>{text}</h1>
				<img src={checkIcon}/>
			</Modal>
		)
	}
}

class AddedToCartModalRender extends Component {
	static contextType = ModalContext;

	nrOfProdInCard = (products) => {
		let nr = 0;
		for (let i = 0; i < products.length; i++) {
			nr = nr + products[i].qty;
		}
		return nr;
	}

	onContinue = () => {
		this.context.toggleModal(false);
		this.props.history.goBack();
	}

	onGoBack = () => {
		this.context.toggleModal(false);
		this.props.history.push("/minFest");
	}

	render(){
		const {product: {name, price, thumbnail}, cart} = this.props;
		const { total, products } = (extractCartData(cart, this.props.products, null));

		return(
			<Modal className="addedToCartModal">
				<h1>Tilføjet til kurven</h1>
				<div className="prodWrapper">
					<img src={getImage(thumbnail)} alt={name}/>
					<div>
						<span className="prodName">{name}</span>
						<span className="prodPrice">{formatPrice(price)} kr</span>
					</div>
				</div>
				<div className="cartInfoWrapper">
					<img src={CartIcon} alt="Kurv"/>
					<div>
						<span className="subTotal">Subtotal {formatPrice(total)} kr.</span>
						<span>{this.nrOfProdInCard(products)} produkter i din kurv</span>
					</div>
				</div>
				<Button onClick={() => this.onGoBack()} className="light">Tilbage til byg</Button>
				<Button onClick={() => this.onContinue()}>Fortsæt med at handle</Button>
			</Modal>
		)
	}
}
export const AddedToCartModal = reduxWrapper("loadProducts", "loadCart", "getCacheProduct")(AddedToCartModalRender);

export const BundleProductModal = ({product:{name, description, price, images}, full = true}) => {
	const context = useContext(ModalContext);

	function close(){
		context.toggleModal(false);
	}

	return(
		<Modal onHide={() => close()} className="bundleProdModal">
			<img className="close" src={closeIcon} onClick={() => close()} alt="Luk"/>
			<img src={getImage(images[0])}/>

			<div className="productDetailsWrapper">
				<div className="productDetails">
					<h1 className="title-l">{name}</h1>
					<div 
						className="productDescriptionWrapper"
						dangerouslySetInnerHTML={{__html: full ? (description ? description : "Ingen beskrivelse") : "Henter..."}}
					/>
				</div>
				<span className="price">
					{formatPrice(this.price || price)}
				</span>
			</div>
		</Modal>
	)
};

export const AddPartyName = ({onSubmit}) => {
	const context = useContext(ModalContext);

	function close(){
		context.toggleModal(false);
	}

	return(
		<Modal onHide={() => close()} className="partyInfoModal" skip>
			<div>
				<h1>Navngiv din fest</h1>
				<ValidateForm onSubmit={name => onSubmit(name)}>
					<FormInput name="name"/>
					<Button submit>GEM</Button>
				</ValidateForm>
			</div>
		</Modal>
	)
};

export const AddPartyDate = ({onSubmit}) => {
	const context = useContext(ModalContext);

	function close(){
		context.toggleModal(false);
	}

	return(
		<Modal onHide={() => close()} className="partyInfoModal" skip>
			<div>
				<h1>Hvornår er festen?</h1>
				<ValidateForm onSubmit={date => onSubmit(date)}>
				<DatetimeInput name="time" placeholder="Vælg dato"/>
					<Button submit>GEM</Button>
				</ValidateForm>
			</div>
		</Modal>
	)
};



// WEBPACK FOOTER //
// ./src/components/common/modal.js